import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../../app/api/api';
import { fetchMealItemCustomizationsAsync } from './mealItemCustomizationSlice';
import { MealItemCustomizationFormData } from '../../../../app/data/models/mealItems/mealItemCustomizationFormData';
import { toMealItemCustomizationModel } from '../../../../app/data/models/mealItems/mealItemCustomizationModel';

export interface CreateCustomizationState {
  status: string;
  dismiss: boolean;
}

const initialState: CreateCustomizationState = {
  status: 'idle',
  dismiss: false,
};

export const createMealItemCustomizationAsync = createAsyncThunk<
  void,
  { restaurantId: string; data: MealItemCustomizationFormData }
>('mealItemCustomizations/create', async ({ restaurantId, data }, thunkApi) => {
  try {
    await api.MealItemCustomization.create(
      restaurantId,
      toMealItemCustomizationModel(data)
    );
    thunkApi.dispatch(fetchMealItemCustomizationsAsync({ restaurantId }));
  } catch (error: unknown) {
    if (error instanceof Error) {
      return thunkApi.rejectWithValue({ error: error.message });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const createMealItemCustomizationSlice = createSlice({
  name: 'createMealItemCustomization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createMealItemCustomizationAsync.pending, (state) => {
      state.status = 'pendingCreateCustomization';
    });
    builder.addCase(createMealItemCustomizationAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(createMealItemCustomizationAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
